import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '../ui/accordion';
import { faqItems } from '../../data/mock';

export const FAQ = () => {
  return (
    <section id="faq" className="bg-black py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Section Header */}
          <div className="lg:sticky lg:top-32 lg:self-start">
            <h2 className="text-3xl md:text-4xl font-semibold text-white leading-tight tracking-tight mb-4">
              Frequently Asked
              <span className="text-[#C9A962]"> Questions</span>
            </h2>
            <p className="text-white/60 text-lg leading-relaxed">
              Everything you need to know about LifeProof AI and how it works.
            </p>
          </div>

          {/* FAQ Accordion */}
          <div>
            <Accordion type="single" collapsible className="space-y-4">
              {faqItems.map((item) => (
                <AccordionItem
                  key={item.id}
                  value={`item-${item.id}`}
                  className="border border-white/10 bg-white/[0.02] px-6 data-[state=open]:border-[#C9A962]/30 transition-colors duration-300"
                >
                  <AccordionTrigger className="text-white text-left text-base font-medium py-5 hover:no-underline hover:text-[#C9A962] transition-colors duration-300 [&>svg]:text-[#C9A962]">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-white/60 text-base leading-relaxed pb-5">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
